/**
Project: Voice Panel (c)
Title: Welcome 
Description: Component to verify the setup if regions are available to start the setup
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Image, Text } from "@fluentui/react-northstar";
import { Grid, Row, Col } from "react-flexbox-grid";
import PageUtil from "../../../../core/helpers/page-util";
import IntlUtil from "../../../../core/helpers/intl-util";
import PeoplePhoneImage from "../../../../../assets/images/illustrations/people_phone.png";
import {
    setDomainSetupProgressPage
} from "../actions/domain-setup-action";
import { VoiceAdminConstants } from "../../common/settings/voice-admin-constants";

class Welcome extends Component {
    _isMounted = false;
    _intl_ns_vpa_domainsetup = "vpa_domainsetup";
    constructor(props) {
        super(props);
        this.state = {};
    }

    setStateAsync = (state) => {
        if (this._isMounted) {
            return new Promise((resolve) => {
                this.setState(state, resolve);
            });
        }
    };

    async componentDidMount() {
        this._isMounted = true;
        PageUtil.scrollToTop();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    loadNextPage = async () => {
        await this.props.setDomainSetupProgressPage(
            VoiceAdminConstants.DOMAIN_SETUP.PROGRESS.ACCOUNT
        );
    };

    render() {
        return (
            <>
                <Grid fluid className="page-grid p-t-25">
                    <Row>
                        <Col xs={12} sm={12} md={8} lg={9} className="m-b-20">
                            <>
                                <Row>
                                    <Col xs={12} className="m-b-10">
                                        <Text className="page-text">
                                            {IntlUtil.getText(
                                                this._intl_ns_vpa_domainsetup,
                                                "content.welcome.routingRegionSetupText"
                                            )}
                                        </Text>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} className="m-b-10">
                                        <Text className="page-text">
                                            {IntlUtil.getText(
                                                this._intl_ns_vpa_domainsetup,
                                                "content.welcome.beginText"
                                            )}
                                        </Text>
                                    </Col>
                                </Row>
                                <Row className="m-t-20 m-b-20">
                                    <Col xs={12} >
                                        <Button
                                            primary
                                            onClick={this.loadNextPage}
                                            content={IntlUtil.getText(
                                                this._intl_ns_vpa_domainsetup,
                                                "content.beginSetup"
                                            )}
                                            className="vpa-voice-setup-button"
                                        />
                                    </Col>
                                </Row>
                            </>
                        </Col>
                        <Col xs={12} sm={12} md={4} lg={3} className="m-b-20">
                            <Image src={PeoplePhoneImage} alt="" className="vpa-dns-page-image" />
                        </Col>
                    </Row>
                </Grid>
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    domainSetupProgressPage: state.domainSetupStore.domainSetupProgressPage,
});

const mapActionToProps = {
    setDomainSetupProgressPage,
};

export default connect(mapStateToProps, mapActionToProps)(Welcome);